import { render } from "./yx-table.vue?vue&type=template&id=65ecf64c"
import script from "./yx-table.vue?vue&type=script&lang=js"
export * from "./yx-table.vue?vue&type=script&lang=js"

import "./yx-table.vue?vue&type=style&index=0&id=65ecf64c&lang=scss"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__